import React from 'react';
import Modal from './Modal';

const ModalFilter: React.FC<{
  onConfirm: () => void;
  onClose: () => void;
  text: string;
}> = ({ onConfirm, onClose, text }) => {
  const confirmAndCloseModal = () => {
    onConfirm();
    onClose();
  };
  return (
    <Modal onClose={onClose} title="Filtros">
      <p className="text-slate-500">{text}</p>
      <input type="text" id="text" className="inputStyles w-full" />
      <div className="mt-7 ml-auto">
        <button onClick={onClose}>Cancelar</button>
        <button onClick={confirmAndCloseModal} className="btn ml-6">
          Confirmar
        </button>
      </div>
    </Modal>
  );
};

export default ModalFilter;
